<section class="section">
  <div class="shortcut-menu card card--no-padding">
    <div class="shortcut-menu__header">
      <h3>{{ "ShortcutMenu.Title" | translate }}</h3>
    </div>
    <div class="shortcut-menu__body">
      @if (docsUrl(); as _docsUrl) {
        <service-documentation-item [url]="_docsUrl" />
      }
    </div>
  </div>
</section>
